const REJECT_FN = Symbol('REJECT_FN');
const RESOLVE_FN = Symbol('RESOLVE_FN');
const STATUS_PROP = Symbol('STATUS_PROP');
const PENDING = Symbol('PENDING');
const FULFILLED = Symbol('FULFILLED');
const REJECTED = Symbol('REJECTED');

class Deferred {
    constructor() {
        this[STATUS_PROP] = PENDING;

        this.promise = new Promise((resolve, reject) => {
            this[REJECT_FN] = reject;
            this[RESOLVE_FN] = resolve;
        });

        this.promise.then(
            () => {
                this[STATUS_PROP] = FULFILLED;
            },
            () => {
                this[STATUS_PROP] = REJECTED;
            }
        );
    }

    static reject (deferred, value) {
        if (!(deferred instanceof Deferred)) {
            throw new TypeError('First argument must be of instance `Deferred`');
        }

        return deferred[REJECT_FN](value);
    }

    static resolve (deferred, value) {
        if (!(deferred instanceof Deferred)) {
            throw new TypeError('First argument must be of instance `Deferred`');
        }

        return deferred[RESOLVE_FN](value);
    }

    static isPending (deferred) {
        return deferred[STATUS_PROP] === PENDING;
    }

    static isRejected (deferred) {
        return deferred[STATUS_PROP] === REJECTED;
    }

    static isFulfilled (deferred) {
        return deferred[STATUS_PROP] === FULFILLED;
    }

    then (callback) {
        this.promise = this.promise.then(callback);
    }

    catch (callback) {
        this.promise = this.promise.catch(callback);
    }

    finally (callback) {
        this.promise = this.promise.finally(callback);
    }
}

export default Deferred;